import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Arrow120 } from "@/components/Arrow120";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch { return ""; }
};

const Blogs = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="blogs-page">
      <section className="pt-28 md:pt-40 pb-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <p className="text-xs uppercase tracking-[0.3em] text-ahm-orange font-semibold mb-6">The Journal</p>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] text-ahm-teal text-balance">
            Notes from the <em className="not-italic text-ahm-orange">studio.</em>
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.article
              key={p.id || i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="group flex flex-col"
              data-testid={`blog-card-${i}`}
            >
              <Link to={`/blogs/${p.slug}`} className="block">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-ahm-muted">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <p className="mt-5 font-mono text-xs uppercase tracking-[0.25em] text-ahm-orange">{fmtDate(p.published_at)}</p>
                <h2 className="font-display text-3xl md:text-4xl text-ahm-teal mt-2 leading-tight group-hover:text-ahm-orange transition-colors">{p.title}</h2>
                <p className="mt-3 text-base text-ahm-teal/75 leading-relaxed">{p.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm text-ahm-teal uppercase tracking-[0.2em] font-semibold group">
                  Read story <Arrow120 size={16} />
                </span>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Blogs;
